import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { MessageBanner } from '@folio/stripes/components';

const ClearanceBanner = ({ clearanceDate, libraryName }) => {
  return (
    <MessageBanner type="warning">
      <FormattedMessage
        id="ui-users.clearance.banner.message"
        values={{ date: clearanceDate, library: libraryName }}
      />
    </MessageBanner>
  );
};

ClearanceBanner.propTypes = {
  clearanceDate: PropTypes.string.isRequired,
  libraryName: PropTypes.string,
};

ClearanceBanner.defaultProps = {
  libraryName: '',
};

export default ClearanceBanner;